import { useScrollAnim } from "src/hooks/hooks"

import LottieWrapper from "@components/global/LottieWrapper"
import animationData from "@public/lottie/lottie_home-journey.json"

function HomeJourney({ data }) {
  const [trigger, anim, inView] = useScrollAnim("slideInUp", 0.25)
  return (
    <section className="sc-home-journey" ref={trigger}>
      {/* <LottieWrapper
        // animationData={animationData}
        animationData="/lottie/lottie_home-journey.json"
        className="home-journey-lottie"
      /> */}
      {inView ? (
        <div className="gradient-wrapper">
          <div className="gradient-left" />
          <div className="gradient-right" />
        </div>
      ) : null}
      <div className="py-main">
        <div className="container">
          <div className="overflow-hidden">
            <div className={anim(1)}>
              <span className="title">{data}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomeJourney
